import { time as T } from "@bracket/tenderly";
import { useWallet, } from "@store";
import { DateTime, } from "luxon";
import { useEffect, useRef, useState, } from "react";
import { getAccount, } from "wagmi/actions";
import { wagmiConfig, } from "@wagmiconfig";




/**
 * 
 * @returns { ready: boolean; time: number; } a ready flag and the time IN UNIX EPOCH MILLISECONDS.
 */
export const useChainTime = () => {


	const { isConnected, } = useWallet();
	const chaintime = !globalThis.location.hostname.startsWith("app.bracket") || !globalThis.location.hostname.startsWith("canary.bracket");
	const [ready, setReady] = useState(false);
	const [time, setTime] = useState(new Date());
	const interval = useRef<NodeJS.Timeout|null>(null);

	useEffect(() => {

		if(!interval.current) {

			const { status, } = getAccount(wagmiConfig);

			interval.current = setInterval(async () => {

				if(chaintime && (isConnected || status === "connected" || status === "reconnecting")) {
					const epochms = await T.getChainTime();
					const next = DateTime.fromMillis(epochms).toJSDate();
					setTime(next);
					setReady(true);
					return;
				}

				setTime(new Date());
				setReady(true);

			}, 1000);
		}

		return () => {

			if(interval.current) {
				clearInterval(interval.current);
				interval.current = null;
			}

		};

	}, [isConnected]);



	return {
		ready,
		time,
	}

}
